import angular from 'angular';
import ngResource from 'angular-resource';

function CouponServ($resource) {
	return $resource('/coupon', {}, {
		'validate': {
			method: 'GET'
		},
	});
}
CouponServ.$inject = ['$resource'];

export default angular.module('services.coupon', [ngResource])
	.service('Coupon', CouponServ)
	.name;



// WEBPACK FOOTER //
// ./project/services/coupon.js